import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-book-shelf",
  "use": "icon-book-shelf-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-book-shelf\"><path d=\"M772 132H252c-34 0-60 26-60 60v640c0 34 26 60 60 60h520c34 0 60-26 60-60V192c0-34-26-60-60-60z m-100 40v218l-32-32c-16-16-40-16-56 0l-32 32V172h120z m120 660c0 12-8 20-20 20H252c-12 0-20-8-20-20V732h560v100zM232 692V192c0-12 8-20 20-20h260v260c0 4 2 8 2 12 2 6 8 12 14 14h4c6 0 10-2 14-6l64-64 64 64c4 4 12 6 18 6 6-2 12-6 14-14 0-2 2-6 2-12V172h60c12 0 20 8 20 20v500H232z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/book-shelf.svg
// module id = cB+X
// module chunks = 65